import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { PaymentsComponent } from './payments/payments.component';
import { HomeComponent } from './home/home.component';
import { BookingComponent } from './booking/booking.component';
import { ConfirmComponent } from './confirm/confirm.component';
import { SuccessComponent } from './success/success.component';
import { ContactusComponent } from './contactus/contactus.component';
import { AboutusComponent } from './aboutus/aboutus.component';
import { DepatureDateComponent } from './mobile/depature-date/depature-date.component';
import { ReturnDateComponent } from './mobile/return-date/return-date.component';
import { MobileFromComponent } from './mobile/mobile-from/mobile-from.component';
import { MobileToComponent } from './mobile/mobile-to/mobile-to.component';
import { ReviewPayComponent } from './review-pay/review-pay.component';
import { MyaccountComponent } from './myaccount/myaccount.component';
import { MynotificationsComponent } from './mynotifications/mynotifications.component';
import { MytripsComponent } from './mytrips/mytrips.component';
import {MobilePassengerComponent} from  './mobile/mobile-passenger/mobile-passenger.component'
import { HotelsRedirectComponent } from './hotels-redirect/hotels-redirect.component';
import { CardProcessComponent } from './card-process/card-process.component';
import { AccountAuthGuard } from './guards/account-auth.guard';
import { FlightRouteComponent } from './seo/flight-route/flight-route.component';
import { flightRouteMatcher, flightRouteResolver } from './seo/flight-route.model';
import { HOME_SEO, NOINDEX, PageSeo } from './seo/seo.service';

const ABOUT_SEO: PageSeo = {
  title: 'About BuuPass Flights | Online Flight Booking in Kenya',
  description: 'BuuPass helps travellers compare and book flights, buses and trains across Kenya and Africa, and pay with M-Pesa, Airtel Money or card.',
  path: 'about-us.html'
};

const CONTACT_SEO: PageSeo = {
  title: 'Contact BuuPass Flights | Customer Support',
  description: 'Need help with a flight booking? Contact the BuuPass customer support team by phone, email or WhatsApp.',
  path: 'contact-us.html'
};



const routes: Routes = [
  { path: '', component: HomeComponent, data: { seo: HOME_SEO } },
  { path: 'home', component: HomeComponent, data: { seo: { ...HOME_SEO, noindex: true } } },
  // Flight route landing pages from seo/flight-routes.json, e.g. /flights/nairobi-to-mombasa.
  // SeoService builds their tags from the resolved `flightRoute`.
  { matcher: flightRouteMatcher, component: FlightRouteComponent, resolve: { flightRoute: flightRouteResolver } },
  { path: 'booking',      component: BookingComponent, data: {animation: 'Booking', seo: NOINDEX}, },
  { path: 'booking/:route', component: BookingComponent, data: {animation: 'Booking', seo: NOINDEX}, },
  { path: 'payments/:id',      component: PaymentsComponent, data: {animation: 'Payments', seo: NOINDEX}, },
  { path: 'booking-successful/:id',      component: SuccessComponent, data: {animation: 'Success', seo: NOINDEX}, },
  { path: 'review-and-pay/:id',      component: ReviewPayComponent, data: {animation: 'Success', seo: NOINDEX}, },
  { path: 'confirm-payments/:id',      component: ConfirmComponent, data: {animation: 'Confirm', seo: NOINDEX}, },
  { path: 'card/confirm/:internal_booking_reference',      component: CardProcessComponent, data: {animation: 'Confirm', seo: NOINDEX}, },
  { path: 'about-us',      component: AboutusComponent, data: {animation: 'About', seo: ABOUT_SEO}, },
  { path: 'contact-us',      component: ContactusComponent, data: {animation: 'COntact', seo: CONTACT_SEO}, },
  { path: 'depature-date',      component: DepatureDateComponent, data: {animation: 'Destination', seo: NOINDEX}, },
  { path: 'return-date',      component: ReturnDateComponent, data: {animation: 'Destination', seo: NOINDEX}, },
  { path: 'mobile-from',      component: MobileFromComponent, data: {animation: 'Destination', seo: NOINDEX}, },
  { path: 'mobile-passenger',      component: MobilePassengerComponent, data: {animation: 'Destination', seo: NOINDEX}, },
  { path: 'mobile-to',      component: MobileToComponent, data: {animation: 'Destination', seo: NOINDEX}, },
  { path: 'accounts',      component: MyaccountComponent, canActivate: [AccountAuthGuard], data: { seo: NOINDEX } },
  { path: 'account', redirectTo: 'accounts', pathMatch: 'full' },
  { path: 'my-notifications', redirectTo: 'accounts', pathMatch: 'full' },
  { path: 'my-trips', redirectTo: 'accounts', pathMatch: 'full' },
  { path: 'hotels',      component: HotelsRedirectComponent, data: { seo: NOINDEX } },
  // Unknown URLs still show the home page, but must not be indexed as duplicates of it.
  { path: '**', component: HomeComponent, data: { seo: NOINDEX } },
];
@NgModule({
  imports: [RouterModule.forRoot(routes, {
    scrollPositionRestoration: 'enabled',
    scrollOffset: [0, 0],
    // Enable scrolling to anchors
    anchorScrolling: "enabled"
})],
  exports: [RouterModule]
})
export class AppRoutingModule { }
